(ns web3.persistence.deletions
  (:require [web3.modals.alerts :as alerts]
            [web3.components.snackbar :as snackbar]
            [web3.routing.core :as routing]
            [re-frame-simple.db :as db]))

(defn delete-with-confirm [{:keys [redirect snack on-complete] :as props}]
  (alerts/add-frame
   [alerts/delete-with-confirmation (assoc props
                                      :on-complete (fn [& args]
                                                     (when redirect
                                                       (routing/nav! redirect))
                                                     (when snack
                                                       (snackbar/add-snack! snack))
                                                     (when on-complete
                                                       (apply on-complete args))))]))

(defn close-deleted-entity-modal! [id]
  (when (and id
             (= id (db/get-in [:db/routers :router/content-modal :route-params :id])))
    (routing/nav! (routing/path-for :router/content-modal nil))))




